import { createElementBlock as e, openBlock as o, createElementVNode as r } from "vue";
import n from "./index289.js";
const l = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function a(c, t, m, p, f, h) {
  return o(), e("svg", s, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "M18.5 11.25a.75.75 0 0 1 .102 1.493l-.102.007h-13a.75.75 0 0 1-.102-1.493l.102-.007h13Zm0 4a.75.75 0 0 1 .102 1.493l-.102.007h-13a.75.75 0 0 1-.102-1.493l.102-.007h13Zm0-8a.75.75 0 0 1 .102 1.493l-.102.007h-13a.75.75 0 0 1-.102-1.493L5.5 7.25h13Z"
    }, null, -1)
  ]));
}
const d = /* @__PURE__ */ n(l, [["render", a]]);
export {
  d as default
};
